import { render, staticRenderFns } from "./StudentBecaReport.vue?vue&type=template&id=226a0eff&"
import script from "./StudentBecaReport.vue?vue&type=script&lang=js&"
export * from "./StudentBecaReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports